import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const InsuranceOptionCard = styled.div<{
  isSelected: boolean;
  isDesktop?: boolean;
}>`
  position: relative;
  background-color: ${(props) => (props.isSelected ? "#F3FAF7" : "#FFF")};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${(props) => (props.isSelected ? "#0FA457" : "#E0E0E8")};
  padding: 16px 20px;
  border-radius: 8px;
  width: ${(props) => (props.isDesktop ? "90%" : "88%")};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-bottom: 10px;
`;

export const PopularTag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 8px;
  gap: 12px;

  position: absolute;
  width: 52px;
  height: 16px;
  left: 0px;
  top: 0px;

  background: linear-gradient(268.98deg, #f66969 -10.35%, #743ddc 106.34%);
  border-radius: 8px 0px;

  flex: none;
  order: 0;
  flex-grow: 0;
  z-index: 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 4px;

  width: 36px;
  height: 16px;

  flex: none;
  order: 0;
  flex-grow: 0;
  display: none;
  width: 16px;
  height: 16px;
  flex: none;
  order: 0;
  flex-grow: 0;
  width: 36px;
  height: 16px;

  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.1px;
  color: #ffffff;
  flex: none;
  order: 1;
  flex-grow: 0;
  // padding: 4px;
  padding-left: 4px;
  padding-right: 4px;
`;

export const TableHeader = styled.div`
  background-color: #f8f7fc;
  border-radius: 8px;
  padding: 8px 20px;
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 12px;
`;

export const SumInsured = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #040222;
`;

export const Price = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #040222;
`;

export const Slabs = styled.div`
  margin-bottom: 30px;
`;

export const ModalHeading = styled.h2`
  position: relative;
  width: 320px;
  height: 56px;
  transform: translateX(-50%);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.1px;
  color: #040222;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  padding-top: 12px;
  padding-bottom: 12px;
  background: transparent;
  z-index: 2;
  left: 46%;
`;

export const Subheading = styled.div`
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #040222;
  margin-bottom: 16px;
  margin-top: ${(props) => (props.isDesktop ? "12px" : "-12px")};
`;

export const HyperlinkStyles = {
  width: "296px",
  height: "20px",
  fontFamily: "'Euclid Circular B', 'Inter', sans-serif",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  color: "#D83D37",
  margin: "0 auto",
  justifyContent: "center",
  order: 1,
  flexGrow: 0,
  marginTop: "1rem"
};
